import { initializeSensitiveWords } from './sensitiveWords';
import { zhWords, enWords, esWords } from './sensitive-words';

const SENSITIVE_WORDS_DATA: Record<SensitiveWordsLanguage, string[]> = {
  zh: zhWords,
  en: enWords,
  es: esWords,
};

export type SensitiveWordsLanguage = 'zh' | 'en' | 'es';

/**
 * 从多个语言加载敏感词并合并
 * @param languages 要加载的语言列表，默认加载所有语言
 * @returns 合并后的敏感词列表
 */
export const loadSensitiveWords = async (
  languages: SensitiveWordsLanguage[] = ['zh', 'en', 'es']
): Promise<string[]> => {
  const allWords = languages.flatMap(lang => SENSITIVE_WORDS_DATA[lang] || []);
  const uniqueWords = Array.from(new Set(allWords));
  return uniqueWords;
};

/**
 * 初始化敏感词列表（从内置数据加载）
 * @param languages 要加载的语言列表，默认加载所有语言
 * @param minMatchLength 最小匹配长度，默认2（忽略单字匹配）。设置为1则检测所有长度
 * @param useWordBoundary 是否使用单词边界检测，默认true（推荐）
 * @returns 加载的敏感词数量
 */
export const initializeSensitiveWordsFromConfig = async (
  languages: SensitiveWordsLanguage[] = ['zh', 'en', 'es'],
  minMatchLength: number = 2,
  useWordBoundary: boolean = true
): Promise<number> => {
  const words = await loadSensitiveWords(languages);
  if (words.length > 0) {
    initializeSensitiveWords(words, minMatchLength, useWordBoundary);
    console.log(`已加载 ${words.length} 个敏感词（语言: ${languages.join(', ')}，最小匹配长度: ${minMatchLength}，单词边界检测: ${useWordBoundary ? '启用' : '禁用'}）`);
  } else {
    console.warn('未加载到任何敏感词');
  }
  return words.length;
};
